import Relay from 'react-relay';

export default class LikeProductMutation extends Relay.Mutation {
  static fragments = {
    product: () => Relay.QL`
      fragment on Product {
        id
      }
    `,
    counters: () => Relay.QL`
      fragment on ProductCounters {
        id
        numLikes
      }
    `,
    viewerMetadata: () => Relay.QL`
      fragment on ProductViewerMetadata {
        id
        viewerHasLiked
      }
    `,
  };

  static defaultProps = {
    action: 'follow',
  };

  getMutation() {
    if (this.props.action === 'like') {
      return Relay.QL`mutation {likeProduct}`;
    }
    return Relay.QL`mutation {unlikeProduct}`;
  }

  getFatQuery() {
    if (this.props.action === 'like') {
      return Relay.QL`
        fragment on LikeProductPayload {
          product {
            likedBy
          }
          counters {
            numLikes
          }
          viewerMetadata {
            viewerHasLiked
          }
        }
      `;
    }
    return Relay.QL`
      fragment on UnlikeProductPayload {
        product {
          likedBy
        }
        counters {
          numLikes
        }
        viewerMetadata {
          viewerHasLiked
        }
      }
    `;
  }

  getOptimisticResponse() {
    const { action } = this.props;

    const numLikes = action === 'like'
      ? this.props.counters.numLikes + 1
      : this.props.counters.numLikes - 1;

    const viewerHasLiked = action === 'like';

    return {
      counters: {
        id: this.props.counters.id,
        numLikes,
      },
      viewerMetadata: {
        id: this.props.viewerMetadata.id,
        viewerHasLiked,
      },
    };
  }

  getConfigs() {
    return [{
      type: 'FIELDS_CHANGE',
      fieldIDs: {
        counters: this.props.counters.id,
        viewerMetadata: this.props.viewerMetadata.id,
        product: this.props.product.id,
      },
    }];
  }

  getVariables() {
    return {
      id: this.props.product.id,
    };
  }
}



// WEBPACK FOOTER //
// ../src/client/apps/shops/mutations/LikeProductMutation.js